<template>
  <div class="content">
    <img src="https://ysh-cdn.kaidicloud.com/test/h5/yscard/yscard-bg1.png" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/h5/yscard/yscard-bg2.png" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/h5/yscard/yscard-btn-bg.png" class="btn-bg" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/h5/yscard/yscard-btn.png" class='btn' alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.content {
  display: flex;
  flex-direction: column;
  position: relative;
}

.btn-bg {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
}

.btn {
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  width: 502px;
}
</style>
